import { AppState } from "../rootReducer"; // not used ? // not used
/*
export const getDeviceId = (state: AppState) => state.device.deviceId;
export const getNotifications = (state: AppState) => state.device.notifications;
export const getNotificationsLed = (state: AppState) =>
  state.device.notificationsLed;
*/
//not used ?
export const getNewMessageNotifications = (state: AppState) =>
  state.notification.newMessageNotifications;

export const getNewHomeNotifications = (state: AppState) =>
  state.notification.newHomeNotifications;

export const getNewGeneralNotifications = (state: AppState) =>
  state.notification.newGeneralNotifications;

export const getNewResourceNotifications = (state: AppState) =>
  state.notification.newResourceNotifications;

export const getAchievement = (state: AppState) =>
  state.notification.achievement;

export const getTeamNotifications = (state: AppState) =>
  state.notification.teamNotifications;

export const getPulseNotifications = (state: AppState) =>
  state.notification.pulseNotifications;

export const getNotificationIsRequesting = (state: AppState) =>
  state.notification.requesting;

export const getNotificationIsLoading = (state: AppState) =>
  state.notification.loading;

export const getNotificationHasResult = (state: AppState) =>
  state.notification.hasResult;

export const getNotificationPage = (state: AppState) => state.notification.page;

export const getNotifications = (state: AppState) =>
  state.notification.notifications;
